import React, { Component } from 'react';
import styled from 'styled-components';

import withi18n from '../../../../utils/withI18n';
import { getLabel } from '../../../../utils/i18n';
import Regrex from '../../../../utils/regrex';
import { Link } from '../../../../routes';
import FlexBox from '../../../../components/FlexBox';

const Container = styled(FlexBox)`
  width: 100%;
  font-size: 14px;
  padding: 20px 0;

  &:not(:first-child) {
    border-top: 1px solid #f6f6f6;
  }

  a {
    text-decoration: none;
  }

  .h5-date {
    padding-bottom: 12px;
    font-size: 12px;
    line-height: 14px;
    color: #333;
  }

  .content {
    flex: 9;
    .title {
      color: #333;
      font-size: 18px;
      line-height: 20px;
      margin-bottom: 12px;
      font-weight: bold;

      a {
        color: #333;

        &:hover {
          color: #f0b90b;
        }
      }
    }

    .first-img {
      display: block;
      width: 100%;
      margin-bottom: 24px;

      > img {
        width: 100% !important;
        max-width: 100% !important;
      }
    }

    .desc {
      color: #666;
      font-size: 16px;
      line-height: 26px;
      word-break: break-word;
      &.detail {
        color: initial;
      }
      video {
        max-width: 100% !important;
      }

      img {
        max-width: 100%;
        height: auto;
      }

      > p {
        flex: 1;
      }
    }

    .more-opt {
      margin-top: 20px;

      .read-btn {
        color: #f0b90b;
        border: 1px solid #f0b90b;
        padding: 5px 10.3px;
        border-radius: 3px;

        a {
          color: #f0b90b;
        }

        &:hover {
          background: #f0b90b;

          a {
            color: #fff;
          }
        }
      }
    }
  }
`;

const stripHtml = (html) => {
  let texts = html.replace(/<!--[\s\S]*?-->/mg, '')
    .replace(/(&nbsp;|\n)/img, '')
    .replace(/<\/?.+?>/mg, '');

  if (texts.length >= 300) {
    texts = `${texts.substr(0, 300)}...`;
  }
  return texts;
};

const getFirstImg = html => html.match(/<img.*?>/);
const formatLink = title => encodeURI(title.replace(Regrex.punctuation, '').replace(/ /g, '-'));

type Props = {
  isDetail: boolean,
  info: Object,
  locale: string,
  i18n: Object,
};

export default
@withi18n
class SingleBlog extends Component<Props> {
  static defaultProps = {
    isDetail: false,
    info: {},
  };

  getListContent() {
    const {
      info, locale, i18n,
    } = this.props;
    const {
      idStr, banner, brief, content, title = '',
    } = info;
    const link = `/${locale}/blog/${idStr}/${formatLink(title)}`;
    const result = [];
    if (brief) {
      result.push(<div key="brief" className="desc">{brief}</div>);
      if (banner) {
        try {
          const bannerObj = JSON.parse(banner);
          const BannerContent = (
            <FlexBox
              key="img"
              className="first-img"
              dangerouslySetInnerHTML={{ __html: `<img src='${bannerObj.bannerUrl}'>` }}
            />
          );
          bannerObj.bannerLocation === 'above' ?
            result.unshift(BannerContent)
            :
            result.push(BannerContent);
        } catch (e) {
          // do nothing
        }
      }
    } else {
      getFirstImg(content) &&
        result.push(<FlexBox
          key="img"
          className="first-img"
          dangerouslySetInnerHTML={{ __html: getFirstImg(content)[0] }}
        />);
      result.push(
        <div
          key="brief"
          direction="column"
          className="desc"
        >
          {stripHtml(content)}
        </div>
      );
    }

    const ReadMoreContent = (
      <FlexBox className="more-opt" key="readmore">
        <FlexBox className="read-btn">
          <Link to={link}>{getLabel('exchange-blog-readmore', i18n, 'Read More')}</Link>
        </FlexBox>
      </FlexBox>
    );

    result.push(ReadMoreContent);

    return result;
  }

  render() {
    const {
      isDetail, info, locale,
    } = this.props;
    const {
      idStr, title = '', content, postTime, createTime,
    } = info;
    const link = `/${locale}/blog/${idStr}/${formatLink(title)}`;
    const date = new Date(postTime || createTime);
    return (
      <Container direction="row">
        <FlexBox className="content" direction="column">
          <FlexBox className="title">
            {
              isDetail ?
                <span>{title}</span> :
                <Link to={link}>{title}</Link>
            }
          </FlexBox>
          <div className="h5-date">
            {`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`}
          </div>
          {
            isDetail ? (
              <div
                direction="column"
                className="desc detail"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: content }}
              />
            ) :
              this.getListContent()
          }
        </FlexBox>
      </Container>
    );
  }
}
